/** The Sets table — swim sets only. Clicking a set selects its lengths. */
import { store } from '../state/store'
import { formatDistance, formatDuration, formatPace } from '../analytics/format'
import { setStrokeColor, setStrokeLabel } from './uiState'

function selectStint(index: number): void {
  const activity = store.activity.value
  const stint = activity?.stints[index]
  if (stint) store.setSelection(stint.lengths.map((l) => l.ordinal))
}

export function StintTable() {
  const s = store.stats.value
  if (!s) return null
  const swimSets = s.stints.filter((st) => !st.isRest)
  const sel = store.selection.value
  const activity = store.activity.value

  return (
    <div class="card rows" style="overflow:hidden">
      <div class="card-pad" style="padding-bottom:10px">
        <div class="card-title">Sets</div>
      </div>
      <div class="thead">
        <div style="width:46px">Set</div>
        <div style="width:96px">Stroke</div>
        <div style="width:56px">Dist</div>
        <div style="width:50px">Time</div>
        <div style="width:62px">Pace</div>
        <div style="width:64px">Rate</div>
        <div style="flex:1">HR</div>
      </div>
      {swimSets.map((st) => {
        const selected =
          !!activity &&
          activity.stints[st.index]!.lengths.every((l) => sel.has(l.ordinal)) &&
          activity.stints[st.index]!.lengths.length > 0
        const setN = swimSets.indexOf(st) + 1
        return (
          <div
            key={st.index}
            class={`row clickable${selected ? ' selected' : ''}`}
            onClick={() => selectStint(st.index)}
          >
            <div style="width:46px; font-weight:600">{setN}</div>
            <div style="width:96px; display:flex; align-items:center; gap:6px" class="muted">
              <span
                class="dot"
                style={`background:${st.stroke !== null ? setStrokeColor(st.stroke) : '#c7c7cc'}`}
              />
              {st.stroke !== null ? setStrokeLabel(st.stroke) : '—'}
            </div>
            <div style="width:56px">{formatDistance(st.distanceM, s.unit)}</div>
            <div style="width:50px">{formatDuration(st.movingMs)}</div>
            <div style="width:62px" class="muted">
              {formatPace(st.paceSecondsPer100)}
            </div>
            <div style="width:64px" class="muted">
              {st.avgStrokeRate ? `${st.avgStrokeRate.toFixed(0)} spm` : '—'}
            </div>
            <div style="flex:1" class="hr-ink">
              {st.avgHr ? `${st.avgHr} bpm` : '—'}
            </div>
          </div>
        )
      })}
    </div>
  )
}
